
import React, { useState, useEffect } from "react";
import { getDatabase, ref, get, onValue, update, set, remove,child  } from "firebase/database";
// Firebase Storage
import { getStorage, uploadBytes, getDownloadURL, ref as storageRef ,deleteObject} from "firebase/storage";
import { useNavigate, useLocation } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import Lottie from "react-lottie-player";
import app from "../../../firebaseConfig";
import { CircularProgress, Box, Typography } from "@mui/material";

import rayoazul from './assets/lottie/rayoazul.json';

import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';

import ProteccionAdmin from "./proteccionadmin";

import "react-toastify/dist/ReactToastify.css";

import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';import {
  DragDropContext,
  Droppable,
  Draggable
} from '@hello-pangea/dnd';


function PantallaPrincipal() {
  const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);
  const location = useLocation();
  const navigate = useNavigate(); // Inicializamos navigate
  const { categoria, mesa } = location.state || {}; // Obtener valores del estado
  const [productos, setProductos] = useState([]);

  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formData, setFormData] = useState({ nombre: "", descripcion: "", img: "", titulo: "", costogr:"", relleno:"", peso:"", tiempo:"", precio: "", costo:"" });

  const [productoEditando, setProductoEditando] = useState(null);
const [camposEditados, setCamposEditados] = useState({});
const [modalAbierto, setModalAbierto] = useState(false);

const [valoresEditados, setValoresEditados] = useState({});

const [subiendo, setSubiendo] = useState(false);
const [urlImagen, setUrlImagen] = useState(null);
const [error, setError] = useState(null);

const [archivoSubido, setArchivoSubido] = useState(null); // ref de Firebase para eliminar

const [nuevaImgUrl, setNuevaImgUrl] = useState(null); // url nueva subida
const [nuevaImgPath, setNuevaImgPath] = useState(null); // path nueva subida
const [imgAnteriorPath, setImgAnteriorPath] = useState(null); // para eliminar si se guarda

const [descripcionDialogOpen, setDescripcionDialogOpen] = useState(false);
const [descripcionHTML, setDescripcionHTML] = useState(formData.descripcion || "");

const [fichaDialogOpen, setfichaDialogOpen] = useState(false);
const [fichaHTML, setfichaHTML] = useState(formData.ficha || "");

  // Arreglo de animaciones disponibles
const animacionesDisponibles = [
  lineasblancasvolando,
  efectoparticulas,
  fuegoamarillo,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  rayoazul,
  neutron,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  ondacircular,
  fuegorojo,
  fuegoamarillo,
];
  const [mostrarAnimacion, setMostrarAnimacion] = useState(true);
  const [carritoCantidad, setCarritoCantidad] = useState(0); // 🔹 Estado del carrito

  const [imagenFile, setImagenFile] = useState(null);
//////////////////////////////////////////

//////////////// Codigo para las variantes
const [variantes, setVariantes] = useState(() => {
  const local = localStorage.getItem("variantesTemp");
  return local ? JSON.parse(local) : {};
});
const [tipoActual, setTipoActual] = useState(""); // para nuevo tipo
const [tipoDialogOpen, setTipoDialogOpen] = useState(false);

const [itemDialogOpen, setItemDialogOpen] = useState(false);
const [tipoSeleccionado, setTipoSeleccionado] = useState(""); // en qué tipo estamos agregando

const [nuevoItem, setNuevoItem] = useState({ cantidad: "", descripcion: "", nombre: "" });
////////////////////

const [camposExtra, setCamposExtra] = useState([]);

/////////// Codigo para IMGS y contenido Visual DEL PRODUCTO
const [archivosSeleccionados, setArchivosSeleccionados] = useState([]);
const [vistaPreviaArchivos, setVistaPreviaArchivos] = useState([]);
const [subiendoArchivos, setSubiendoArchivos] = useState(false);
const subirArchivosYGuardarOrden = async () => {
  setSubiendoArchivos(true);
  const storage = getStorage(app);
  const urls = [];

  for (let i = 0; i < vistaPreviaArchivos.length; i++) {
    const item = vistaPreviaArchivos[i];
  
    if (!item.file) {
      console.warn("⚠️ Archivo inválido o faltante en vistaPreviaArchivos:", item);
      continue;
    }
  
    const nombreArchivo = `productos/${item.file.name}`;
    const refArchivo = storageRef(storage, nombreArchivo);
  
    await uploadBytes(refArchivo, item.file);
    const url = await getDownloadURL(refArchivo);
  
    urls.push({ url, tipo: item.type, orden: i });
  }
  

  // Guardar en la base de datos
  const db = getDatabase();
  const productoRef = ref(db, `nature/Awoo/Categorias/${categoria}/${formData.nombre}/Visuales`);
  await set(productoRef, urls);

  alert("✅ Archivos subidos con éxito");
  setSubiendoArchivos(false);
};
//////////////////////
const [isUploading, setIsUploading] = useState(false);

// estado para las imágenes seleccionadas para el item actual
const [imagenesSeleccionadas, setImagenesSeleccionadas] = useState([]);


/////////Trae si existe algo en LocalStorage sobre DESCRIPCIÓN Y FICHA TECNICA
useEffect(() => {
  const desc = localStorage.getItem("descripcionTemp");
  if (desc) {
    setDescripcionHTML(desc);
    setFormData(prev => ({ ...prev, descripcion: desc }));
  }
  const fich = localStorage.getItem("fichaTemp");
  if (fich) {
    setfichaHTML(fich);
    setFormData(prev => ({ ...prev, ficha: fich }));
  }
}, []);
//////////////////////////////
// Guardamos los datos de forma reactiva en LocalStorage cuando cambian VARIANTES FORMDATA
useEffect(() => {
  localStorage.setItem("formDataTemp", JSON.stringify(formData));
  localStorage.setItem("variantesTemp", JSON.stringify(variantes));
}, [formData, variantes]);
// Recuperamos la información guardada en localStorage
useEffect(() => {
  const localFormData = localStorage.getItem("formDataTemp");
  const localVariantes = localStorage.getItem("variantesTemp");

  if (localFormData) {
    setFormData(JSON.parse(localFormData));
  }
  if (localVariantes) {
    setVariantes(JSON.parse(localVariantes));
  }
}, []);
///////////////////////////////////////////////////////////





/////////////////////////Verificación al cargar la página para eliminacion de img EDITADA x
useEffect(() => {
  const pathPendiente = localStorage.getItem("imagenTemporalPath");
  if (pathPendiente) {
    const storage = getStorage();
    const refPendiente = storageRef(storage, pathPendiente);

    deleteObject(refPendiente)
      .then(() => {
        console.log("🗑️ Imagen temporal eliminada al iniciar el componente");
        localStorage.removeItem("imagenTemporalPath");
      })
      .catch((e) => console.warn("❌ No se pudo eliminar imagen temporal al iniciar:", e));
  }
}, []);
/////////////////////////Verificación al cargar la página para eliminacion de img CREADA
useEffect(() => {
  const pathPendiente = localStorage.getItem("imgPendienteEliminar");

  // Validar si pathPendiente es una cadena válida y no el string 'undefined' ni 'null'
  if (
    pathPendiente &&
    typeof pathPendiente === "string" &&
    pathPendiente.trim() !== "" &&
    pathPendiente !== "undefined" &&
    pathPendiente !== "null"
  ) {
    try {
      const storage = getStorage(app);
      const refImagen = storageRef(storage, pathPendiente);

      deleteObject(refImagen)
        .then(() => {
          console.log("🗑️ Imagen eliminada automáticamente tras reload");
          localStorage.removeItem("imgPendienteEliminar");
        })
        .catch((err) => {
          console.warn("⚠️ No se pudo eliminar la imagen pendiente:", err);
        });
    } catch (error) {
      console.error("❌ Error al intentar eliminar imagen:", error);
    }
  } else {
    // Si no es válido, lo eliminamos igual del localStorage por seguridad
    localStorage.removeItem("imgPendienteEliminar");
  }
}, []);
// 🔹 Función para obtener el carrito desde localStorage
const obtenerCarrito = () => {
  const carrito = localStorage.getItem("carrito");
  return carrito ? JSON.parse(carrito) : [];
};
// 🔹 Obtener carrito al cargar la página
useEffect(() => {
      setCarritoCantidad(obtenerCarrito().length);
}, []);
//////////////////////////////////////////////////////////////////////
useEffect(() => {
  if (!categoria) {
    navigate("/awoogeneral");
    return;
  }

  const db = getDatabase(app);
  const productosRef = ref(db, `nature/Awoo/Categorias/${categoria}`);

  get(productosRef).then((snapshot) => {
    if (snapshot.exists()) {
      const productosData = snapshot.val();
      const listaProductos = Object.keys(productosData).map((key) => ({
        id: key,
        ...productosData[key],
      }));
      setProductos(listaProductos);
    } else {
      // Si no existe la categoría en Firebase
      navigate("/awoogeneral");
    }
  });
}, [categoria, navigate]);
////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);

////////////////////////
useEffect(() => {
  if (modalAbierto && productoEditando) {
    setValoresEditados({ ...productoEditando });
  }
}, [modalAbierto, productoEditando]);


///////////////
const abrirEditorProducto = (producto) => {
  setProductoEditando(producto);
  setCamposEditados({}); // Limpia campos anteriores
  setModalAbierto(true);
};

///////////////////
  // Función para subir la imagen y obtener la URL
  const subirImagenYObtenerURL = async (archivo) => {
    try {
      setSubiendo(true);
      setError(null);
  
      const storage = getStorage(app);
      const path = `imagenes/${archivo.name}`;
      const refImagen = storageRef(storage, path);
  
      const snapshot = await uploadBytes(refImagen, archivo);
      const url = await getDownloadURL(snapshot.ref);
  
      setUrlImagen(url);
      setFormData((prev) => ({ ...prev, img: url }));
  
      // Guarda temporalmente el path para eliminarlo si se recarga la página
      localStorage.setItem("imgPendienteEliminar", path);
  
      alert("✅ Imagen subida correctamente.");
    } catch (err) {
      console.error("❌ Error al subir imagen:", err);
      setError("Ocurrió un error al subir la imagen.");
      alert("❌ Error al subir la imagen.");
    } finally {
      setSubiendo(false);
    }
  };  
  const eliminarImagenSubida = async () => {
    if (archivoSubido) {
      try {
        await deleteObject(archivoSubido);
        console.log("🗑️ Imagen eliminada de Firebase Storage");
      } catch (err) {
        console.error("❌ Error al eliminar la imagen:", err);
      }
      setArchivoSubido(null);
      setUrlImagen("");
      setFormData((prev) => ({ ...prev, img: "" }));
    }
  };
  /////////////////////////////
  const subirNuevaImagen = async (file) => {
    const storage = getStorage();
    const nombreArchivo = `productos/${Date.now()}_${file.name}`;
    const imgRef = storageRef(storage, nombreArchivo);
  
    await uploadBytes(imgRef, file);
    const url = await getDownloadURL(imgRef);
  
    setNuevaImgUrl(url);
    setNuevaImgPath(nombreArchivo); // Guardamos la ruta para poder eliminarla si cancela
    localStorage.setItem("imagenTemporalPath", nombreArchivo);

  
    // Si había una imagen anterior, guardar su path
    if (productoEditando?.Img && productoEditando.Img.includes("firebasestorage.googleapis.com")) {
      try {
        // Extraemos la ruta anterior del link (hack basado en cómo Firebase forma las URLs)
        const urlDecoded = decodeURIComponent(productoEditando.Img);
        const regex = /\/o\/(.*?)\?/;
        const match = urlDecoded.match(regex);
        if (match && match[1]) {
          setImgAnteriorPath(match[1]);
        }
      } catch (e) {
        console.warn("No se pudo extraer path de la imagen anterior.");
      }
    }
  
    // Seteamos el nuevo valor editable
    setCamposEditados((prev) => ({
      ...prev,
      Img: url,
    }));
  };
  //////////
const guardarCambiosProducto = async () => {
  if (!productoEditando || Object.keys(camposEditados).length === 0) return;

  const db = getDatabase();
  const categoriasRef = ref(db, "nature/Awoo/Categorias");

  try {
    const snapshot = await get(categoriasRef);
    if (snapshot.exists()) {
      const categorias = snapshot.val();
      for (const categoria in categorias) {
        const productos = categorias[categoria];
        for (const key in productos) {
          const producto = productos[key];
          if (producto.Titulo === productoEditando.Titulo) {
            const productoRef = ref(db, `nature/Awoo/Categorias/${categoria}/${key}`);
            await update(productoRef, camposEditados);


            if (imgAnteriorPath && nuevaImgPath) {
              const storage = getStorage();
              const imgAnteriorRef = storageRef(storage, imgAnteriorPath);
              try {
                await deleteObject(imgAnteriorRef);
                console.log("✅ Imagen anterior eliminada");
              } catch (e) {
                console.warn("❌ No se pudo eliminar imagen anterior:", e);
              }
            }

            alert("✅ Producto actualizado correctamente.");
            localStorage.removeItem("imagenTemporalPath");
            setModalAbierto(false);
            window.location.reload(); // Recargar para reflejar cambios
            return;
          }
        }
      }
    }
  } catch (error) {
    console.error("❌ Error actualizando producto:", error);
  }


 
  
};
  //////////////////////////////////////


  const handleCloseDialog = async () => {
    await eliminarImagenSubida();
    setOpenAddDialog(false);
  };
  const handleArchivoSeleccionado = async (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;

    await subirImagenYObtenerURL(archivo);
  };
//////////////////////

const handleAddProduct = async () => {
  // 🟡 0. Evitar duplicar subidas
  if (isUploading) {
    alert("⏳ Ya se está subiendo un producto, por favor espera a que termine.");
    return;
  }

  // 🟡 1. Validar campos obligatorios
  if (
    !formData.nombre ||
    !formData.descripcion ||
    !formData.ficha ||
    !formData.precio ||
    !formData.costo ||
    !formData.precioanterior
  ) {
    alert("⚠️ Todos los campos son obligatorios.");
    return;
  }

  try {
    setIsUploading(true);

    const storage = getStorage();
    const db = getDatabase();

    // 🟢 2. Subir imágenes de la sección VISUALES (manteniendo el orden)
    const imagenesOrdenadas = [];
    const mapping = {}; // previewURL -> storageURL

    for (const preview of vistaPreviaArchivos) {
      if (preview.url.includes("firebasestorage.googleapis.com")) {
        imagenesOrdenadas.push(preview.url);
        mapping[preview.url] = preview.url;
        continue;
      }

      if (preview.file) {
        const nombreArchivo = `productos/${Date.now()}_${preview.file.name}`;
        const fileRef = storageRef(storage, nombreArchivo);
        const snapshot = await uploadBytes(fileRef, preview.file);
        const url = await getDownloadURL(snapshot.ref);
        imagenesOrdenadas.push(url);
        mapping[preview.url] = url;
      }
    }

    // 🟣 3. Mapear imágenes dentro de las variantes (para reemplazar blobs)
    const variantesConURLs = JSON.parse(JSON.stringify(variantes)); // Clonamos

    for (const tipo in variantesConURLs) {
      for (const key in variantesConURLs[tipo]) {
        const item = variantesConURLs[tipo][key];
        if (Array.isArray(item.Imagenes)) {
          item.Imagenes = item.Imagenes.map(
            (previewUrl) => mapping[previewUrl] || previewUrl
          );
        }
      }
    }

    // 🟡 4. Estructurar "Visuales" como objeto con orden, tipo y url
    const visualesEstructurados = {};
    imagenesOrdenadas.forEach((url, index) => {
      visualesEstructurados[index] = {
        orden: index,
        tipo: "imagen",
        url: url,
      };
    });

    // 🟡 5. Guardar producto en Firebase Database
    await set(ref(db, `nature/Awoo/Categorias/${categoria}/${formData.nombre}`), {
      Descripción: formData.descripcion,
      Variantes: variantesConURLs,
      Ficha: formData.ficha,
      Img: imagenesOrdenadas[0] || "", // portada = primera imagen
      Visuales: visualesEstructurados, // ✅ estructura compatible
      Titulo: formData.nombre,
      Costogr: parseInt(formData.costogr, 10) || 0,
      Relleno: parseInt(formData.relleno, 10) || 0,
      Peso: parseInt(formData.peso, 10) || 0,
      Tiempo: formData.tiempo,
      PrecioAnterior: parseInt(formData.precioanterior, 10) || 0,
      Precio: parseInt(formData.precio, 10) || 0,
      Costo: parseInt(formData.costo, 10) || 0,
      visibilidad: "Si",
    });

    // 🧹 6. Limpieza completa
    localStorage.removeItem("imgPendienteEliminar");
    localStorage.removeItem("variantesTemp");
    localStorage.removeItem("descripcionTemp");
    localStorage.removeItem("fichaTemp");

    setOpenAddDialog(false);
    setFormData({
      nombre: "",
      descripcion: "",
      ficha: "",
      img: "",
      titulo: "",
      costogr: "",
      relleno: "",
      peso: "",
      tiempo: "",
      precioanterior: "",
      precio: "",
      costo: "",
    });
    setVariantes({});
    setVistaPreviaArchivos([]);

    alert("✅ Producto subido correctamente.");
    window.location.reload();

  } catch (error) {
    console.error("❌ Error al subir producto:", error);
    alert("❌ Ocurrió un error al subir el producto. Revisa la consola para más detalles.");
  } finally {
    setIsUploading(false);
  }
};

const handleDeleteProduct = () => {
  if (!selectedProduct) return;
  const db = getDatabase();
  remove(ref(db, `nature/Awoo/Categorias/${categoria}/${selectedProduct}`)).then(() => {
    setOpenDeleteDialog(false);
    setSelectedProduct(null);
    window.location.reload(); // Recarga la página para reflejar los cambios
  });
};

////////////////
const eliminarVariante = (tipo) => {
  const copia = { ...variantes };
  delete copia[tipo];
  setVariantes(copia);
};

const eliminarItem = (tipo, itemKey) => {
  const copia = { ...variantes };
  delete copia[tipo][itemKey];
  setVariantes(copia);
};



///////////////////////////////////////
  // Función para navegar a awoovistaitem.js
  const verProducto = (producto) => {
    navigate("/awoovistaitem", {
      state: { categoria, producto, mesa }, // Enviamos categoría y producto
    });
  };
//lógica para cambiar visibilidad y actualizar Firebase
  const toggleVisibilidad = async (producto) => {
    const db = getDatabase();
    const productoRef = ref(db, `nature/Awoo/Categorias/${categoria}/${producto.Titulo}`);
    const nuevaVisibilidad = producto.visibilidad === "Si" ? "No" : "Si";
  
    try {
      await update(productoRef, { visibilidad: nuevaVisibilidad });
      const nuevosProductos = productos.map((p) =>
        p.Titulo === producto.Titulo ? { ...p, visibilidad: nuevaVisibilidad } : p
      );
      setProductos(nuevosProductos);
    } catch (error) {
      console.error("Error al cambiar visibilidad:", error);
    }
  };
  ////////////////////////////////////////

  if (!animacionSeleccionada) return null; // Muestra nada mientras se selecciona la animación
////////////////////////////////////////////////////////////////////////////////////



  // 🔹 Función para redirigir al resumen de compras
  const irAlCarrito = () => {
    navigate("/3dfyrionresumen", { state: { mesa } });
  };

  return (

    <ProteccionAdmin>

<div style={{ display: 'flex', height: '100vh', overflow: 'hidden' ,maxWidth: "100%",  background: 'linear-gradient(135deg,rgb(0, 0, 0),rgb(0, 0, 0))', // Fondo degradado blanco a azul
      position: 'relative', // Necesario para posicionar el contenido y la animación de fondo
      }}>
  {/* Contenido deslizable */}
  <div
    style={{
      flex: 1, // Esto asegura que ocupe todo el espacio disponible arriba de la barra
      overflowY: 'auto', // Permite el scroll vertical en el contenido
    }}
  >
    {/* Aquí va todo el contenido deslizable */}
    <div style={{ width:'100%'}}>
     
    <div
    style={{
      background: 'linear-gradient(135deg, rgb(0, 0, 0),rgb(0, 0, 0))', // Fondo degradado blanco a azul
      position: 'relative', // Asegura que el contenido esté en una capa superior
      width:'100%'
    }}
  >
 
    {/* Boton LOGO Y Carrito de Compras */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between", // Alinea los elementos en los extremos
        alignItems: "center", // Centra verticalmente
        width: "100%", // Usa todo el ancho disponible
        padding: "10px", // Espaciado interno
        position: "relative", // Mantiene posiciones relativas
      }}
    >
      {/* --- Logo y Animación --- */}
      <div
        style={{
          marginLeft: "28px",
          display: "flex",
          alignItems: "center", // Centra verticalmente
          position: "relative",
        }}
      >
        <Lottie
          animationData={animacionSeleccionada}
          play
          loop
          style={{
            position: "absolute",
            width: "200px",
            height: "200px",
            top: "-50px",
            left: "-50px",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            position: "relative",
            width: "85px",
            height: "85px",
            borderRadius: "50%",
            overflow: "hidden",
            zIndex: 1,
          }}
        >
          <img
            src={"images/awoo.png"}
            alt="Logo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
        </div>
      </div>

      {/* --- Tarjeta Mesa (Centrada) --- */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <div
          style={{
            width: "60px",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "relative",
              borderRadius: "15px",
              overflow: "visible",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "60px",
                backgroundColor: "black",
                borderRadius: "50%",
                border: "5px solid #2ae5e2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <input
                value={mesa}
                type="text"
                style={{
                  color:"white",
                  width: "60px",
                  height: "50px",
                  fontSize: "26px",
                  fontWeight: "bold",
                  textAlign: "center",
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                }}
              />
            </div>

            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "60%",
                transform: "translateX(-50%)",
                width: "80%",
                backgroundColor: "#fff",
                color: "#6bb01c",
                padding: "8px",
                borderRadius: "10px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
             Mesa {mesa}
            </div>
          </div>
        </div>
      </div>

{/* --- Icono Carrito Compras (Se oculta si carritoCantidad es 0) --- */}
{carritoCantidad > 0 && (
  <div
    onClick={irAlCarrito}
    style={{
      marginRight: "28px",
      position: "relative",
      width: "60px",
      cursor: "pointer",
    }}
  >
    <div
      style={{
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        border: "5px solid #2ae5e2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "url('images/carrito.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    ></div>

    {/* Etiqueta inferior con cantidad */}
    <div
      style={{
        position: "absolute",
        bottom: "-10px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#fa0a02",
        color: "white",
        padding: "4px 8px",
        borderRadius: "10px",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "12px",
      }}
    >
      {carritoCantidad}
    </div>
  </div>
)}

    </div>





  {/* ESTILO CUADRO NEGRO */}
  <div
      className="container"
      style={{
        backgroundColor:'#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '10px',
         width:'100%'
      }}
    >

    </div>
      {/* ESTILO CUADRO AZUL */}
  <div
      className="container"
      style={{
        backgroundColor:'#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
         height: '5px',
      }}
    >

    </div>

{/* Sección de Productos */}
{/* -- Titulo Productos */}
<div
  style={{
    display: "flex",
    alignItems: "center", // Alinea elementos verticalmente
    gap: "10px", // Espacio entre elementos
    marginBottom: "20px",
    textAlign: "left",
    marginLeft: "35px",
    color: "white",
  }}
  
>
    
          <div
            style={{
              display: "flex",
              marginTop: "15px",
              flexDirection: "row", // Disposición horizontal
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              width: "150px", // Aumenta el ancho mínimo para dar espacio
              cursor: "pointer",
            }}
          >
            <strong style={{ color: "#000000", fontSize: "15px" }}>{"🚀 Productos"}</strong>
            <div
              style={{
                marginLeft: "auto", // Empuja el conteo al lado derecho
                padding: "5px 10px",
                backgroundColor: "#26e9f6",
                borderRadius: "15px",
                color: "#ffffff",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {"+"}
            </div>
          </div>


           <div
            style={{
              display: "flex",
              marginTop: "15px",
              flexDirection: "row", // Disposición horizontal
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              marginLeft: "10px",
              backgroundColor: "#5abe18",
              borderRadius: "10px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              width: "140px", // Aumenta el ancho mínimo para dar espacio
              cursor: "pointer",
            }}
          >
            <strong style={{ color: "#fff", fontSize: "15px" }}>{categoria}</strong>
        
          </div>

{/* Imagen 1 */}
<div
    style={{
      backgroundColor: "#2ae5e2",
      borderRadius: "50%",
      padding: "2px", // Espacio para que se vea el borde
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "15px",
    }}
  >
    <img
      src={"images/ad.jpg"}
      alt="Agregar"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
      }}
      onClick={() => setOpenAddDialog(true)} 
    />
  </div>

  {/* Imagen 2 */}
  <div
    style={{
      backgroundColor: "#2ae5e2",
      borderRadius: "50%",
      padding: "2px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "15px",
    }}
  >
    <img
      src={"images/bor.jpg"}
      alt="Logo"
      style={{
        width: "35px",
        height: "35px",
        borderRadius: "50%",
      }}
      onClick={() => setOpenDeleteDialog(true)} 
    />



{/* Dialogo de agregar */}
<Dialog open={openAddDialog}   
  disablePortal={true}
  keepMounted 
onClose={() => {
    eliminarImagenSubida();
    setOpenAddDialog(false);
  }}>
        <DialogTitle>Agregar Producto</DialogTitle>
        <DialogContent>
          <TextField label="Nombre" fullWidth onChange={(e) => setFormData({ ...formData, nombre: e.target.value })} />
        

          <Typography variant="subtitle1">Descripción:</Typography>
<Button
  variant="outlined"
  onClick={() => {
    setDescripcionHTML(formData.descripcion || "");
    setDescripcionDialogOpen(true);
  }}
>
  ✍️ Editar descripción avanzada
</Button>


<Typography variant="subtitle1">Variantes:</Typography>
<Button variant="outlined" onClick={() => setTipoDialogOpen(true)}>+ Añadir Tipo de Variante</Button>
{Object.entries(variantes).map(([tipo, items]) => (
 <Box key={tipo} mt={2} p={1} border="1px solid #ccc" borderRadius={2}>
 <Box display="flex" justifyContent="space-between" alignItems="center">
   <Typography variant="h6">{tipo}</Typography>
   <Button
     size="small"
     onClick={() => eliminarVariante(tipo)}
     style={{
       backgroundColor: "red",
       color: "white",
       borderRadius: "50%",
       minWidth: "30px",
       padding: 0,
       fontWeight: "bold",
     }}
   >
     X
   </Button>
 </Box>

 <Button variant="outlined" size="small" onClick={() => {
  setTipoSeleccionado(tipo);
  setNuevoItem({ nombre: "", descripcion: "", cantidad: "" }); // reiniciar
  setImagenesSeleccionadas([]); // limpiar selección previa
  setCamposExtra([]); // si usas camposExtra
  setItemDialogOpen(true);
}}>+ Añadir {tipo}</Button>


 {Object.entries(items).map(([key, item]) => (
   <Box key={key} mt={1} ml={2} display="flex" justifyContent="space-between" alignItems="center">
     <Typography>
       - {item.Nombre} ({item.Cantidad}): {item.Descripción}
     </Typography>
     <Button
       size="small"
       onClick={() => eliminarItem(tipo, key)}
       style={{
         backgroundColor: "red",
         color: "white",
         borderRadius: "50%",
         minWidth: "25px",
         padding: 0,
         marginLeft: "10px",
         fontWeight: "bold",
       }}
     >
       X
     </Button>
   </Box>
 ))}
</Box>


))}


         
          <Typography variant="subtitle1">Ficha Técnica:</Typography>

<Button
  variant="outlined"
  onClick={() => {
    setfichaHTML(formData.ficha || "");
    setfichaDialogOpen(true);
  }}
>
  ✍️ Editar ficha avanzada
</Button>
 
<TextField
  label="Costo gr (Filamento)"
  fullWidth
  value={formData.costogr}
  onChange={(e) => {
    const valorSoloNumeros = e.target.value.replace(/[^0-9]/g, ""); // elimina todo excepto números
    setFormData({ ...formData, costogr: valorSoloNumeros });
  }}
/>  
<TextField
  label="Relleno (%)"
  fullWidth
  value={formData.relleno}
  onChange={(e) => {
    const valorSoloNumeros = e.target.value.replace(/[^0-9]/g, ""); // elimina todo excepto números
    setFormData({ ...formData, relleno: valorSoloNumeros });
  }}
/>   
<TextField
  label="Peso (gr)"
  fullWidth
  value={formData.peso}
  onChange={(e) => {
    const valorSoloNumeros = e.target.value.replace(/[^0-9]/g, ""); // elimina todo excepto números
    setFormData({ ...formData, peso: valorSoloNumeros });
  }}
/>   
<TextField
  label="Tiempo (Estimado)"
  fullWidth
  value={formData.tiempo}
  onChange={(e) => {
    setFormData({ ...formData, tiempo: e.target.value });
  }}
/> 

<TextField
  label="PrecioAnterior ($)"
  fullWidth
  value={formData.precioanterior}
  onChange={(e) => {
    const valorSoloNumeros = e.target.value.replace(/[^0-9]/g, ""); // elimina todo excepto números
    setFormData({ ...formData, precioanterior: valorSoloNumeros });
  }}
/>     
<TextField
  label="Precio ($)"
  fullWidth
  value={formData.precio}
  onChange={(e) => {
    const valorSoloNumeros = e.target.value.replace(/[^0-9]/g, ""); // elimina todo excepto números
    setFormData({ ...formData, precio: valorSoloNumeros });
  }}
/>
<TextField
  label="Costo ($)"
  fullWidth
  value={formData.costo}
  onChange={(e) => {
    const valorSoloNumeros = e.target.value.replace(/[^0-9]/g, "");
    setFormData({ ...formData, costo: valorSoloNumeros });
  }}
/>


<input
  type="file"
  multiple
  accept="image/*,video/*"
  onChange={(e) => {
    const files = Array.from(e.target.files);
    setArchivosSeleccionados(files);

    const previews = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
      type: file.type.startsWith("video") ? "video" : "imagen"
    }));

    setVistaPreviaArchivos(previews);
  }}
/>


{openAddDialog && (
  <DragDropContext
    onDragEnd={(result) => {
      if (!result.destination) return;
      const items = Array.from(vistaPreviaArchivos);
      const [reordenado] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reordenado);
      setVistaPreviaArchivos(items);
    }}
  >
    <Droppable droppableId="archivos">
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          style={{ display: "flex", flexWrap: "wrap", minHeight: 100 }}
        >
          {vistaPreviaArchivos.map((preview, index) => (
            <Draggable
              key={preview.url}
              draggableId={preview.url}
              index={index}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style={{
                    margin: 10,
                    padding: 10,
                    border: "1px solid #ccc",
                    borderRadius: 8,
                    ...provided.draggableProps.style,
                  }}
                >
                  {preview.type === "imagen" ? (
                    <img src={preview.url} alt="preview" width={150} />
                  ) : (
                    <video width={150} controls>
                      <source src={preview.url} />
                    </video>
                  )}
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
)}







<Button
  variant="outlined"
  color="secondary"
  onClick={() => {
    localStorage.removeItem("formDataTemp");
    localStorage.removeItem("variantesTemp");
    localStorage.removeItem("descripcionTemp");
    localStorage.removeItem("fichaTemp");
    setFormData({
      nombre: "",
      descripcion: "",
      precioanterior: "",
      precio: "",
      costo: "",
      img: "",
      ficha: "",
      titulo: "",
    });
    setVariantes({});
    alert("Todos los datos han sido limpiados.");
  }}
>
  Limpiar Todo
</Button>


        </DialogContent>
        <DialogActions>
          <Button   onClick={() => {
    eliminarImagenSubida();
    setOpenAddDialog(false);
  }}>Cancelar</Button>
          <Button onClick={handleAddProduct}>Agregar</Button>
        </DialogActions>
</Dialog>



{/* Dialogo descripción avanzada */}
<Dialog
  open={descripcionDialogOpen}
  onClose={() => setDescripcionDialogOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>Editor de Descripción</DialogTitle>
  <DialogContent>
    <ReactQuill
      value={descripcionHTML}
      onChange={setDescripcionHTML}
      modules={{
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'image'],
          ['clean']
        ]
      }}
      style={{ height: '300px' }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDescripcionDialogOpen(false)}>Cancelar</Button>
    <Button
      onClick={() => {
        setFormData({ ...formData, descripcion: descripcionHTML });
        setDescripcionDialogOpen(false);
        localStorage.setItem("descripcionTemp", descripcionHTML);
      }}
    >
      Guardar Descripción
    </Button>
  </DialogActions>
</Dialog>
{/* Dialogo ficha avanzada */}
<Dialog
  open={fichaDialogOpen}
  onClose={() => setfichaDialogOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>Editor de Ficha</DialogTitle>
  <DialogContent>
    <ReactQuill
      value={fichaHTML}
      onChange={setfichaHTML}
      modules={{
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'image'],
          ['clean']
        ]
      }}
      style={{ height: '300px' }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setfichaDialogOpen(false)}>Cancelar</Button>
    <Button
      onClick={() => {
        setFormData({ ...formData, ficha: fichaHTML });
        setfichaDialogOpen(false);
        localStorage.setItem("fichaTemp", fichaHTML);
      }}
    >
      Guardar Ficha
    </Button>
  </DialogActions>
</Dialog>



{/* Dialog para agregar nuevo tipo de variante */}
<Dialog open={tipoDialogOpen} onClose={() => setTipoDialogOpen(false)}>
  <DialogTitle>Nuevo Tipo de Variante</DialogTitle>
  <DialogContent>
    <TextField
      label="Tipo (Color, Tamaño...)"
      fullWidth
      value={tipoActual}
      onChange={(e) => setTipoActual(e.target.value)}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setTipoDialogOpen(false)}>Cancelar</Button>
    <Button onClick={() => {
      if (tipoActual.trim() !== "") {
        setVariantes({ ...variantes, [tipoActual]: {} });
        setTipoActual("");
        setTipoDialogOpen(false);
      }
    }}>Agregar</Button>
  </DialogActions>
</Dialog>
{/* Dialog para agregar un ítem a una variante */}
<Dialog open={itemDialogOpen} onClose={() => setItemDialogOpen(false)}>
  <DialogTitle>Añadir a {tipoSeleccionado}</DialogTitle>
  <DialogContent>
    <TextField
      label="Nombre"
      fullWidth
      margin="dense"
      value={nuevoItem.nombre}
      onChange={(e) => setNuevoItem({ ...nuevoItem, nombre: e.target.value })}
    />
    <TextField
      label="Descripción"
      fullWidth
      margin="dense"
      value={nuevoItem.descripcion}
      onChange={(e) => setNuevoItem({ ...nuevoItem, descripcion: e.target.value })}
    />
    <TextField
      label="Cantidad"
      fullWidth
      margin="dense"
      value={nuevoItem.cantidad}
      onChange={(e) => setNuevoItem({ ...nuevoItem, cantidad: e.target.value })}
    />

    {/* Campos extras */}
    {camposExtra.map((campo) => (
      <TextField
        key={campo}
        label={campo}
        fullWidth
        margin="dense"
        value={nuevoItem[campo] || ""}
        onChange={(e) =>
          setNuevoItem({ ...nuevoItem, [campo]: e.target.value })
        }
      />
    ))}

    <Box mt={2}>
      <Button
        variant="outlined"
        size="small"
        onClick={() => {
          const nuevoCampo = prompt("Nombre del nuevo campo:");
          if (nuevoCampo && nuevoCampo.trim() !== "" && !camposExtra.includes(nuevoCampo)) {
            setCamposExtra([...camposExtra, nuevoCampo]);
          }
        }}
      >
        + Añadir campo personalizado
      </Button>
    </Box>

    {/* ---------------- Selección de imágenes para este item ---------------- */}
    <Box mt={2}>
      <Typography variant="subtitle1">Selecciona las imágenes para este item:</Typography>
      <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
        {vistaPreviaArchivos.length === 0 && (
          <Typography variant="body2">Aún no hay imágenes subidas en "Visuales".</Typography>
        )}
        {vistaPreviaArchivos.map((preview, idx) => {
          const url = preview.url; // objeto que ya construyes con URL.createObjectURL o url real
          const checked = imagenesSeleccionadas.includes(url);
          return (
            <label key={url} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 120, margin: 6 }}>
              <div style={{ width: 100, height: 100, overflow: "hidden", borderRadius: 8, border: "1px solid #ddd", display: "flex", alignItems: "center", justifyContent: "center" }}>
                {preview.type === "imagen" ? (
                  <img src={url} alt="preview" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                ) : (
                  <video src={url} style={{ maxWidth: "100%", maxHeight: "100%" }} />
                )}
              </div>
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => {
                  if (e.target.checked) {
                    setImagenesSeleccionadas(prev => [...prev, url]);
                  } else {
                    setImagenesSeleccionadas(prev => prev.filter(u => u !== url));
                  }
                }}
                style={{ marginTop: 6 }}
              />
              <span style={{ fontSize: 12, textAlign: "center", marginTop: 4 }}>
                {preview.file?.name ? preview.file.name.slice(0, 18) : `Img ${idx + 1}`}
              </span>
            </label>
          );
        })}
      </Box>
    </Box>
    {/* -------------------------------------------------------------------- */}

  </DialogContent>
  <DialogActions>
    <Button onClick={() => setItemDialogOpen(false)}>Cancelar</Button>
    <Button
      onClick={() => {
        if (!nuevoItem.nombre || !nuevoItem.descripcion || !nuevoItem.cantidad) {
          alert("Nombre, Descripción y Cantidad son obligatorios.");
          return;
        }

        const nuevosItems = { ...variantes[tipoSeleccionado] };
        const nextIndex = Object.keys(nuevosItems).length + 1;

        // Construir el objeto con todos los campos e incluir Imagenes
        const itemFinal = {
          Nombre: nuevoItem.nombre,
          Descripción: nuevoItem.descripcion,
          Cantidad: nuevoItem.cantidad,
          Imagenes: imagenesSeleccionadas // <-- aquí guardamos la referencia
        };

        camposExtra.forEach((campo) => {
          itemFinal[campo] = nuevoItem[campo] || "";
        });

        nuevosItems[nextIndex] = itemFinal;

        setVariantes({
          ...variantes,
          [tipoSeleccionado]: nuevosItems
        });

        // limpiar modal y estados
        setNuevoItem({ nombre: "", descripcion: "", cantidad: "" });
        setCamposExtra([]);
        setImagenesSeleccionadas([]);
        setItemDialogOpen(false);
      }}
    >
      Guardar
    </Button>
  </DialogActions>
</Dialog>




{/* Dialogo de borrar */}
<Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Borrar Producto</DialogTitle>
        <DialogContent>
          {productos.map((producto) => (
            <div
              key={producto.id}
              style={{
                padding: "10px",
                margin: "5px 0",
                cursor: "pointer",
                backgroundColor: selectedProduct === producto.id ? "red" : "white",
                color: selectedProduct === producto.id ? "white" : "black",
              }}
              onClick={() => setSelectedProduct(producto.id)}
            >
              {producto.id}
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancelar</Button>
          <Button onClick={handleDeleteProduct} disabled={!selectedProduct}>Borrar</Button>
        </DialogActions>
</Dialog>

  </div>

</div>

{/* -- CARDVIEWS Productos */}
<div 
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "5px 0",
      }}
    >
      <div 
        style={{
          width: "90%",
          backgroundColor: "#000",
          borderRadius: "15px",
          padding: "15px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        {/* Contenedor de tarjetas con Grid */}
        <div 
          style={{ 
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
            gap: "15px",
            justifyContent: "center",
            paddingBottom: "10px",
          }}
        >
          {/* Renderizar productos dinámicamente */}
          {productos.map((producto) => (
            <div key={producto.id}
              onClick={() => verProducto(producto.Titulo)} // Evento para navegar
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
                padding: "10px",
                textAlign: "center",
                border: "3px solid #02f2fa",
                boxShadow: "0 0 10px rgba(2, 242, 250, 0.7)",
                cursor: "pointer", // Cursor para indicar que es clickeable

  
              }}

              
            >
                 {/* CardView Circular de visibilidad */}
    <div
        onClick={(e) => {
          e.stopPropagation(); // Evita que navegue
          toggleVisibilidad(producto);
        }}
      style={{
        position: "absolute",
        backgroundColor: producto.visibilidad === "Si" ? "green" : "red",
        position: "absolute",
        border: "2px solid #02f2fa",
        borderRadius: "50%",
        marginLeft:"30px",
        width: "30px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
        zIndex: 10,
      }}
    >
      👁️
    </div>

<button
    onClick={(e) => {
      e.stopPropagation(); // Evita que navegue
      abrirEditorProducto(producto);
    }}
    style={{
      position: "absolute",
      backgroundColor: "#fff",
      border: "2px solid #02f2fa",
      borderRadius: "50%",
      width: "30px",
      height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      cursor: "pointer",
      boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
      zIndex: 10,
    }}
  >
    🔐
  </button>

  {(() => {
  let imagenUrl = producto.Img;

  if (!imagenUrl && producto.Visuales) {
    const visualesArray = Object.values(producto.Visuales)
      .filter((item) => item && item.tipo === "imagen")
      .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));

    if (visualesArray.length > 0) {
      imagenUrl = visualesArray[0].url;
    }
  }

  return (
    <img
      src={imagenUrl || "images/default.jpg"}
      alt={producto.Titulo || "Producto"}
      style={{
        width: "100%",
        height: "180px",
        objectFit: "cover",
        borderRadius: "10%",
      }}
    />
  );
})()}
              <div style={{ color: "black", fontWeight: "bold", marginTop: "10px" }}>
                {producto.Titulo || ""}
              </div>
              <div style={{ color: "#9a9c9a", fontSize: "14px" }}>
                {producto.Descripcion || "3dfyrion"}
              </div>
              <div style={{ marginTop: "10px", fontWeight: "bold", fontSize: "14px", color: "black" }}>
                ⭐ {producto.Calificacion || "4.9"}
              </div>
              <div 
                style={{
                  marginTop: "5px",
                  backgroundColor: "#e27f0e",
                  color: "white",
                  padding: "5px",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                ${producto.Precio?.toLocaleString("es-CO") || "0"}
              </div>
              
            </div>
          ))}
          
    
        </div>


        {modalAbierto && productoEditando && (
  <div style={{
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 999
  }}>
    <div style={{
      backgroundColor: "#fff",
      padding: 20,
      borderRadius: 10,
      width: "300px",
    }}>
      <h3>Editar Producto</h3>
      {["Titulo", "Descripcion", "Img", "Precio", "Costo"].map((campo) => (
  <div key={campo} style={{ marginBottom: 10 }}>
    <label>{campo}</label>
    <input
      type="text"
      value={valoresEditados[campo] || ""}
      onChange={(e) => {
        let nuevoValor = e.target.value;

        // Validar solo números para Precio y Costo
        if (campo === "Precio" || campo === "Costo") {
          nuevoValor = nuevoValor.replace(/[^0-9]/g, ""); // Solo dígitos
        }

        const actualizado = {
          ...valoresEditados,
          [campo]: nuevoValor,
        };
        setValoresEditados(actualizado);

        // Verificar si cambió frente al producto original
        if (nuevoValor !== String(productoEditando[campo])) {
          setCamposEditados((prev) => ({
            ...prev,
            [campo]: campo === "Precio" || campo === "Costo" ? Number(nuevoValor) : nuevoValor,
          }));
        } else {
          const copia = { ...camposEditados };
          delete copia[campo];
          setCamposEditados(copia);
        }
      }}
      style={{ width: "100%", padding: "6px" }}
    />
  </div>
))}
  
  <div style={{ marginBottom: 10 }}>
  <label>Subir nueva imagen</label>
  <input
    type="file"
    accept="image/*"
    onChange={(e) => {
      const archivo = e.target.files[0];
      if (archivo) {
        subirNuevaImagen(archivo);
      }
    }}
  />
</div>


      <button
        disabled={Object.keys(camposEditados).length === 0}
        onClick={guardarCambiosProducto}
        style={{
          marginTop: 10,
          backgroundColor: Object.keys(camposEditados).length === 0 ? "#ccc" : "#00c853",
          color: "#fff",
          padding: "10px",
          border: "none",
          borderRadius: "5px",
          width: "100%",
          cursor: Object.keys(camposEditados).length === 0 ? "not-allowed" : "pointer"
        }}
      >
        Guardar Cambios
      </button>
      <button
        onClick={() => {
          // Si se subió una nueva imagen y se cancela, eliminarla
          if (nuevaImgPath) {
            const storage = getStorage();
            const nuevaRef = storageRef(storage, nuevaImgPath);
            deleteObject(nuevaRef)
              .then(() => console.log("Imagen temporal eliminada"))
              .catch((e) => console.warn("No se pudo eliminar imagen temporal:", e));
              
          
          }
          localStorage.removeItem("imagenTemporalPath");
        
          setModalAbierto(false);
          setNuevaImgUrl(null);
          setNuevaImgPath(null);
          setImgAnteriorPath(null);
          setCamposEditados({});
          

        }}
        
        style={{
          marginTop: 10,
          backgroundColor: "#f44336",
          color: "#fff",
          padding: "10px",
          border: "none",
          borderRadius: "5px",
          width: "100%"
        }}
      >
        Cancelar
      </button>
    </div>
  </div>
)}

      </div>
    </div>


      </div>

    </div>

  </div>

 
</div>

    </ProteccionAdmin>

    );
  }
  
  export default PantallaPrincipal;
  
